import LayoutNested from '@/components/layouts/LayoutNested.vue'

export default {
  path: '/service/:serviceKey',
  component: LayoutNested,
  children: [
    //
  ],
}